export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_ATHILA_2.9b515512.jpg";